import { IDashboardState } from "../models";
import { DashboardActionTypes } from "../models/dashboardActions";
import {
    GET_PACKS,
    CREATE_PACK,
    DELETE_PACK,
    INCREASE_PACK_TOTAL_PLAN,
    DECREASE_PACK_TOTAL_PLAN,
} from "../types";

export default (state: IDashboardState = {}, action: DashboardActionTypes): IDashboardState => {
    switch (action.type) {
        case GET_PACKS:
            if (action.payload.loading) {
                return {
                    loading: true,
                };
            } else if (action.payload.error) {
                return {
                    error: true,
                };
            }
            return {
                packs: action.payload.data!.packs,
            };
        case CREATE_PACK:
            return {
                packs: [...state.packs!, { ...action.payload, totalPlans: 0 }],
            };
        case DELETE_PACK:
            return {
                packs: state.packs!.filter(pack => pack._id !== action.payload),
            };
        case INCREASE_PACK_TOTAL_PLAN:
            return {
                packs: state.packs!.map(pack => {
                    if (pack._id === action.payload) {
                        return {
                            ...pack,
                            totalPlans: pack.totalPlans! + 1,
                        };
                    }
                    return pack;
                }),
            };
        case DECREASE_PACK_TOTAL_PLAN:
            return {
                packs: state.packs!.map(pack => {
                    if (pack._id === action.payload) {
                        return {
                            ...pack,
                            totalPlans: pack.totalPlans! - 1,
                        };
                    }
                    return pack;
                }),
            };
        default:
            return state;
    }
};
